<template>
    <section class="contact-section">
        <div class="container">
            <!-- Desktop Layout: Side by side -->
            <div class="contact-main">
                <div class="left-column">
                    <div class="contact-header">
                        <h2 class="section-title">Fragen stellen</h2>
                        <p class="section-subtitle">Offen, transparent und ehrlich</p>
                    </div>

                    <div class="contact-content">
                        <div class="contact-text">
                            <p>
                                In den vergangenen 6 Jahren war es mir stets wichtig, zuzuhören, Ihre Themen aufzunehmen
                                und ernst zu nehmen. Viele Anregungen und Fragen haben Sie mir in den
                                Bürgersprechstunden mitgegeben – von ganz alltäglichen Dingen bis hin zu größeren
                                Projekten. Einiges konnte ich direkt beantworten, anderes habe ich mitgenommen,
                                recherchiert und im Nachgang geklärt.
                                Damit diese Fragen nicht nur im kleinen Kreis beantwortet bleiben, greife ich nun einige
                                davon auch hier auf. So können alle Bürgerinnen und Bürger nachvollziehen, welche Themen
                                Sie bewegen und welche Antworten oder Lösungen es dazu gibt.
                            </p>
                            <p>
                                Genauso möchte ich weitermachen: Stellen Sie mir Ihre Frage, ich beantworte sie hier auf
                                meiner Seite – selbstverständlich anonym. So entsteht nach und nach eine Sammlung, die
                                zeigt, was Sie beschäftigt, und wie wir gemeinsam Schritt für Schritt weiterkommen.
                            </p>
                        </div>
                    </div>

                    <div class="question-column">
                        <!-- Question Section - Input box for writing questions -->
                        <div class="question-section">
                            <input v-model="quickQuestion" class="question-title" type="text"
                                placeholder="Ihre Frage" />
                        </div>

                        <!-- Send Question Button - Sends to s.fritzsche@pixelstein.de -->
                        <div class="send-question">
                            <button @click="sendQuickQuestion" class="send-question-btn">
                                FRAGE SENDEN
                            </button>
                        </div>
                    </div>
                </div>

                <div class="questions-column">
                    <!-- Questions List -->
                    <div class="questions-list">
                        <div v-for="question in questions" :key="question.id" class="question-item">
                            <div class="question-header" @click="toggleQuestion(question.id)">
                                <h3 class="question-title">{{ question.question }}</h3>
                            </div>

                            <!-- Expandable Answer -->
                            <div v-if="question.expanded" class="question-answer">
                                <p class="answer-text">{{ question.answer }}</p>
                                <button @click="toggleQuestion(question.id)" class="close-answer-btn">
                                    Antwort schließen
                                </button>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>

        <!-- Contact Form Modal -->
        <div v-if="showContactForm" class="modal-overlay" @click.self="closeContactForm">
            <div class="modal-content">
                <div class="modal-header">
                    <h3 class="modal-title">Ihre Frage</h3>
                    <button class="modal-close" @click="closeContactForm">×</button>
                </div>

                <div class="modal-body">
                    <form @submit.prevent="submitForm" class="contact-form">
                        <div class="form-group">
                            <textarea class="form-control" rows="4" placeholder="Ihre Frage oder Anregung"
                                v-model="form.message" required readonly></textarea>
                        </div>
                        <div class="form-group captcha-group">
                            <label>Captcha: Bitte geben Sie die Zeichen ein</label>
                            <div class="captcha-image">
                                <img :src="captchaImageUrl" alt="Captcha" @click="refreshCaptcha"
                                    style="cursor: pointer; border: 1px solid #ccc;">
                                <button type="button" @click="refreshCaptcha" class="refresh-captcha-btn">⟳ Neu
                                    laden</button>
                            </div>
                            <input type="text" class="form-control" placeholder="Captcha eingeben"
                                v-model="captchaAnswer" required>
                        </div>
                        <button type="submit" class="btn-submit" :disabled="!isCaptchaValid || isSubmitting">
                            {{ isSubmitting ? 'Wird gesendet...' : 'Frage senden' }}
                        </button>
                    </form>
                </div>
            </div>
        </div>

        <!-- Thank You Modal -->
        <ThankYouModal v-if="showThankYouModal" @close="closeThankYouModal" />
    </section>
</template>

<script>
import ThankYouModal from './ThankYouModal.vue'

export default {
    name: 'ContactSection',
    components: {
        ThankYouModal
    },
    data() {
        return {
            showContactForm: false,
            showThankYouModal: false,
            isSubmitting: false,
            form: {
                message: ''
            },
            captchaImageUrl: '',
            captchaAnswer: '',
            quickQuestion: '',
            questions: [
            // MOCK DATA FOR LOCAL TESTING   
            //    {
            //        id: 1,
            //        question: "Wann wird endlich die Bahnhofsstraße saniert?",
            //        answer: "Die Sanierung der Bahnhofsstraße ist bereits in Planung. Die ersten Arbeiten beginnen voraussichtlich im Frühjahr 2024. Wir investieren dabei in moderne Infrastruktur, bessere Beleuchtung und barrierefreie Gehwege. Der gesamte Bauabschnitt wird in Etappen durchgeführt, um die Belastung für Anwohner und Geschäfte so gering wie möglich zu halten.",
            //        expanded: false
            //    },
            //    {
            //        id: 2,
            //        question: "Gibt es Pläne für mehr Kitaplätze in Roßdorf?",
            //        answer: "Ja, wir arbeiten intensiv daran. Eine neue Kita mit 75 Plätzen ist bereits genehmigt und wird noch in diesem Jahr fertiggestellt. Zusätzlich prüfen wir weitere Standorte, da wir den steigenden Bedarf ernst nehmen. Unser Ziel ist es, dass alle Kinder einen wohnortnahen Betreuungsplatz erhalten.",
            //        expanded: false
            //    },
            //    {
            //        id: 3,
            //        question: "Warum dauert die Digitalisierung in der Verwaltung so lange?",
            //        answer: "Die Digitalisierung ist ein komplexer Prozess, den wir systematisch angehen. Bereits jetzt können viele Anträge online gestellt werden. Bis Ende 2024 werden weitere Services digital verfügbar sein. Wichtig ist uns dabei, dass die Systeme sicher und benutzerfreundlich sind – das braucht Zeit, zahlt sich aber langfristig aus.",
            //        expanded: false
            //    },
            //    {
            //        id: 4,
            //        question: "Was passiert mit dem alten Rathaus?",
            //        answer: "Das alte Rathaus wird zu einem Bürger- und Kulturzentrum umgebaut. Dort sollen Vereine Räume finden, kulturelle Veranstaltungen stattfinden und ein Café entstehen. Die Planungen laufen bereits, und wir beziehen die Bürgerinnen und Bürger aktiv in den Prozess mit ein. Eine offizielle Bürgerbeteiligung ist für das kommende Jahr geplant.",
            //        expanded: false
            //    },
            //    {
            //        id: 5,
            //        question: "Wann kommt endlich besseres Internet in die Außenbereiche?",
            //        answer: "Der Glasfaserausbau ist eine unserer Prioritäten. In Zusammenarbeit mit den Anbietern werden bis 2025 alle Ortsteile an das Hochgeschwindigkeitsnetz angeschlossen. Die Arbeiten in Niederissigheim und Butterstadt beginnen bereits im nächsten Quartal. Wir setzen uns dafür ein, dass niemand digital abgehängt wird.",
            //        expanded: false
            //    }
            ]
        }
    },
    computed: {
        isCaptchaValid() {
            return this.captchaAnswer && this.captchaAnswer.trim().length > 0
        }
    },
    mounted() {
        this.loadCaptcha()
        this.loadQuestions()
    },
    methods: {
        loadCaptcha() {
            this.captchaImageUrl = `/server/generate-captcha.php?t=${Date.now()}`
        },
        async loadQuestions() {
            try {
                const response = await fetch('/server/get-faqs.php')
                if (response.ok) {
                    const data = await response.json()
                    this.questions = data.map(q => ({ ...q, expanded: false }))
                }
            } catch (error) {
                console.error('Error loading FAQ questions:', error)
            }
        },
        refreshCaptcha() {
            this.captchaAnswer = ''
            this.loadCaptcha()
        },
        openQuestionForm() {
            this.loadCaptcha()
            this.showContactForm = true
            document.body.style.overflow = 'hidden'
        },
        closeContactForm() {
            this.showContactForm = false
            document.body.style.overflow = 'auto'
        },
        async submitForm() {
            if (this.isSubmitting) return

            this.isSubmitting = true

            try {
                const response = await fetch('/server/submit-question.php', {
                    method: 'POST',
                    credentials: 'include',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        message: this.form.message,
                        captchaAnswer: this.captchaAnswer
                    })
                })

                const result = await response.json()

                if (result.success) {
                    this.showContactForm = false
                    this.showThankYouModal = true

                    // Reset form
                    this.form = {
                        message: ''
                    }
                    this.captchaAnswer = ''
                    this.loadCaptcha()
                } else {
                    alert(result.error || 'Fehler beim Senden der Nachricht')
                }
            } catch (error) {
                console.error('Error submitting form:', error)
                alert('Fehler beim Senden der Nachricht. Bitte versuchen Sie es später erneut.')
            } finally {
                this.isSubmitting = false
            }
        },
        closeThankYouModal() {
            this.showThankYouModal = false
            document.body.style.overflow = 'auto'
        },
        toggleQuestion(questionId) {
            const question = this.questions.find(q => q.id === questionId)
            if (question) {
                question.expanded = !question.expanded
            }
        },
        sendQuickQuestion() {
            if (this.quickQuestion.trim()) {
                // Pre-populate the modal with the quick question
                this.form.message = this.quickQuestion
                this.loadCaptcha()
                this.showContactForm = true
                document.body.style.overflow = 'hidden'
                // Clear the quick question input
                this.quickQuestion = ''
            }
        }
    }
}
</script>